"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TasksModel = /** @class */ (function () {
    function TasksModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/tasks",
            UPDATE: APPURL + "/api/v1/tasks",
            CREATE: APPURL + "/api/v1/tasks",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    TasksModel.prototype.extract = function (result) {
        return result.data;
    };
    TasksModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    TasksModel.prototype.getTaskByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    TasksModel.prototype.get = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    TasksModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    TasksModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    TasksModel.prototype.destroy = function (task) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + task.id)
            .then(this.cacheResults);
    };
    return TasksModel;
}());
TasksModel.$inject = ["$http", "APPURL"];
exports.default = TasksModel;
